module.exports = __webpack_public_path__ + "media/images/e-bilet/e-bilet-8154a3d1ade156168671ebb9a468f8c2.svg";